import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const BilingualToggle = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'hi' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="fixed bottom-6 right-6 z-50 bg-[#1A1A1A] border border-[#C9A84C]/20 text-[#C9A84C] px-4 py-2 rounded-full text-xs uppercase tracking-widest hover:bg-[#C9A84C]/10 backdrop-blur-md flex items-center gap-2 transition-all"
      data-testid="bilingual-toggle-button"
    >
      <Globe className="w-4 h-4" />
      {i18n.language === 'en' ? 'हिंदी' : 'English'}
    </button>
  );
};

export default BilingualToggle;